const AT = require("../core/vault/ActionTypes");
const UpdateSchool = require("./vault/UpdateSchool");

const initialize = function(vault, updater) {
	UpdateSchool.augment(updater);
	vault.dispatchNow({type: AT.SCHOOL_INITIAL});
	vault.dispatchNow({type: AT.REPORT_INITIAL});
};

module.exports = {
	initialize,

	PageSchool: require("./PageSchool"),
	PageSchoolTestList: require("./PageSchoolTestList"),
	PageClassReports: require("./PageClassReports"),
	PageStaffProfile: require("./PageStaffProfile"),
	// Page for printing class cards
	PageClassCards: require("./PageClassCards"),
	// Page just for printing problem modal
	PagePrintStudentProblem: require("./PagePrintStudentProblem"),
};
